import React from 'react';
import { Field } from 'redux-form';
import renderRadio from './form-radio';
import { Form } from 'semantic-ui-react';

const renderRadioGroup = (fields) => {
  const showError = fields[fields.radioName] && fields[fields.radioName].meta.touched && fields[fields.radioName].meta.error;

  return (
    <Form.Group className={ `radio-field${showError ? ' input-error' : ''}` }>
      <Field
        label="Yes"
        value="Yes"
        type="radio"
        name={ fields.radioName }
        customClass={ fields.customClass }
        component={ renderRadio }
      />
      <Field
        label="No"
        value="No"
        type="radio"
        name={ fields.radioName }
        customClass={ fields.customClass }
        component={ renderRadio }
      />
      {showError && <label className="ui label basic error-message">{fields.errorMessage}</label>}
    </Form.Group>);
};

export default renderRadioGroup;
